import { render } from "./HighlightCard.vue?vue&type=template&id=274a830a"
import script from "./HighlightCard.vue?vue&type=script&lang=js"
export * from "./HighlightCard.vue?vue&type=script&lang=js"
script.render = render

export default script